import { Form } from 'react-final-form';
import { useViewedVehicle } from '../../hooks/useViewedVehicle';
import { IncreaseAmount } from '../../../../../components/IncreaseAmount';
import { useCurrentUser } from '../../../../../hooks/selectors';
import myBidsApiSlice, { usePlaceBidMutation } from '../../../../../services/api/my-bids';
import { useDispatch } from 'react-redux';
import { snackShow } from '../../../../../actions';
import { AUCTION_STATUSES, BUYER_VEHICLE_STATUS } from '../../../../../constants';
import { auctionOfferStatuses } from '../../../../../utils/statusCalculator';
import { resetFilters } from 'services/byMids/myBidsSlice';
import { getMinBitAmount } from 'utils/vehicle';

export const IncreaseMaxBid = () => {
  const vehicle = useViewedVehicle();
  const user = useCurrentUser();
  const [placeBid] = usePlaceBidMutation();
  const dispatch = useDispatch();

  if (!vehicle) return null;
  if (user.role !== 'buyer') return null;

  const initialAmount = getMinBitAmount(vehicle, user);
  const status = auctionOfferStatuses(vehicle, null, user);

  const canPlaceBid =
    [BUYER_VEHICLE_STATUS.OUT_BID, BUYER_VEHICLE_STATUS.HIGH_BID, BUYER_VEHICLE_STATUS.ACTIVE].includes(status) &&
    vehicle.auction?.status === AUCTION_STATUSES.ACTIVE;

  if (!canPlaceBid) return null;

  const onSubmit = async (values: { amount: string }) => {
    const response = await placeBid({
      vehicle_id: vehicle.id,
      amount: Number(values.amount)
    });

    if ('data' in response) {
      dispatch(snackShow({ message: 'Bid successfully placed' }));
    } else {
      dispatch(snackShow({ type: 'error', message: (response.error as any)?.data?.message || 'Failed to place bid' }));
    }

    dispatch(resetFilters());
    dispatch(myBidsApiSlice.util.invalidateTags(['MyBids', 'MobileMyBids']));
  };

  return (
    <Form onSubmit={onSubmit} initialValues={{ amount: initialAmount }} name="increase-max-bid">
      {props => (
        <IncreaseAmount
          isProxyAmount={vehicle.proxy_bid?.user_id === user.id}
          type="bid"
          initialAmount={initialAmount}
        />
      )}
    </Form>
  );
};
